import owd from 'owd/owd';
import Dropzone from 'dropzone';

Dropzone.autoDiscover = false;

export default class Upload extends owd.Component {
	init() {
        let defaultError = this.$element.find('.error-message').html();
        let accept = this.$element.data('accept');
        this.inputSelector = this.$element.data('upload');
        this.dropzone = new Dropzone(this.$element[0], {
            url: ajaxurl + '?action=owd_forms_upload',
            autoProcessQueue: true,
            maxFiles: 1,
            uploadMultiple: false,
            acceptedFiles: accept,
            addRemoveLinks: true,
            sending: (e, response) => {
                this.$element.removeClass('has-error');
            },
            success: (e, response) => {
                this.$element.removeClass('has-error');
                response = $.parseJSON(response);
                $(this.inputSelector).val(response.result.id);
            },
            error: (e, response) => {
                response = $.parseJSON(response);

                this.dropzone.removeAllFiles();
                $(this.inputSelector).val('');
                this.$element.addClass('has-error');
                
                if (response.error) {
                    this.$element.find('.error-message').html(response.error);
                } else {
                    this.$element.find('.error-message').html(defaultError);
                }
            },
            removedFile: (e) => {
                $(this.inputSelector).val('');
            }
        });

        this.on('success', this.$element.parents('form'), () => {
            this.dropzone.removeAllFiles();
            $(this.inputSelector).val('');
            this.$element.removeClass('has-error');
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('upload', {
	component: Upload
});